import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import MakeRequest from '../Components/Helpers/MakeRequest';
import { useOutletContext } from 'react-router-dom';
import GoogleMaps from "../Components/GoogleMaps.jsx";

const Retail = () => {
  const { l } = useOutletContext();

  const [retailers, setRetailers] = useState([]);
  const BATCH = 12; // 4 rows × 3 columns (lg=4) => 12 cards per batch
  const [visibleCount, setVisibleCount] = useState(BATCH);
  const [mapsApi, setMapsApi] = useState(null);
  const [filteredMapsApi, setFilteredMapsApi] = useState([]);
  const [visibleRetailers, setVisibleRetailers] = useState([]);
  const [originalMapsApi, setOriginalMapsApi] = useState([]);

  useEffect(() => {
    const fetchRetailers = async () => {
      try {
        const response = await MakeRequest(null, 'content/retailers', 'get');
        setRetailers(response.data || []);
        setVisibleRetailers((response.data || []).sort((a, b) => a.title.localeCompare(b.title)));
      } catch (error) {
        console.error('Error fetching retailers:', error);
      }
    };
    fetchRetailers();
  }, []);

  // Reset pagination if list changes
  useEffect(() => {
    setVisibleCount(BATCH);
  }, [retailers.length]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchAdresses = async () => {
      let addressInfo = [];

      for (const retailer of retailers.filter(r => r.geoCode && r.geoCode.length > 0)) {
        addressInfo.push({
          googledata: retailer.geoCode[0],
          title: retailer.company
        })
      };

      setOriginalMapsApi(addressInfo);
      setMapsApi(addressInfo);
    };
    if (retailers.length > 0) {
      fetchAdresses();
    }
  }, [retailers]);

  const bgColors = ["#f8f9fa", "#e9ecef", "#dee2e6"]; // light gray variations
  const canShowMore = visibleCount < retailers.length;

  useEffect(() => {
    setVisibleRetailers(retailers.filter(r => filteredMapsApi.some(f => f.title === r.company)).sort((a, b) => a.title.localeCompare(b.title)));
  }, [filteredMapsApi])

  return (
    <Container className="my-lg-5 my-3">
      <div className="mb-5">
        <h1 className="mb-3 fw-bold">
          {l('Nordiska Återförsäljare', 'Nordic Retailers')}
        </h1>
        {/* <p className="text-muted lead mb-0">
          {l('En del av vårt sortiment finner ni hos våra återförsäljare.',
            'Part of our assortment is available from our retailers.'
          )}<br />
          {l(' För större order eller om de inte har produkten i lager kontakta oss:', ' For larger orders or if they do not have the products in stock, please contact us:')}
        </p> */}
        {/* <p className="text-muted lead mb-0 mt-3">
          <strong>Tel:</strong> 08 590 737 50<br />
          <strong>Email:</strong> info@introteknik.se
        </p> */}
      </div>

      <Row>
        <div className="rounded-3 overflow-hidden border shadow-sm">
          <GoogleMaps
            mapsApi={filteredMapsApi.length ? filteredMapsApi : mapsApi}
            apiKey={process.env.GOOGLE_API_KEY}
            l={l}
            setFilteredMapsApi={setFilteredMapsApi}
            originalMapsApi={originalMapsApi}
          />
        </div>
      </Row>

      <Row className='mt-2' style={{ zIndex: 10000}}>
        {visibleRetailers.slice(0, visibleCount).map((retailer, index) => (
          <Col
            key={retailer._id?.$oid || retailer._id || index}
            xs={12}
            sm={6}
            lg={4}
            className="mb-4 p-lg-2 p-0"
          >
            <Card
              className="h-100 shadow-sm"
              style={{
                borderRadius: "15px",
                backgroundColor: bgColors[index % bgColors.length],
              }}
            >
              <Card.Body>
                <Card.Title className="mb-3">{retailer.title}</Card.Title>
                <Card.Text className="mb-3" style={{ whiteSpace: "pre-line" }}>
                  {retailer.content}
                </Card.Text>
                <Card.Link
                  href={retailer.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="stretched-link text-primary fw-bold"
                >
                  {l('Besök hemsida →', 'Visit website →')}
                </Card.Link>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {canShowMore && (
        <div className="text-center mt-3">
          <Button variant="primary" onClick={() => setVisibleCount(v => v + BATCH)}>
            {l('Visa mer', 'Show more')}
          </Button>
        </div>
      )}
    </Container>
  );
};

export default Retail;
